import Icon from "./icons/Icon";
import "./WegKarte.css";

/**
 * Karte fuer einen Weg (Start: Mitspielen / Spiel hosten): Icon, Titel,
 * Satz, darunter die Knoepfe (children).
 * @category bausteine
 */
export function WegKarte({ icon, blau = false, titel, text, children }) {
  return (
    <section className="weg-karte">
      <div className="weg-kopf">
        <span className={`weg-ikon${blau ? " blau" : ""}`}>
          <Icon name={icon} size={22} />
        </span>
        <span className="weg-text">
          <b>{titel}</b>
          <small>{text}</small>
        </span>
      </div>
      {children}
    </section>
  );
}

export default WegKarte;
